<template>
  <node :config="config" :title="config.name" :show-error="showError" :content="content" :error-info="errorInfo"
        @selected="$emit('selected')" @delNode="$emit('delNode')" @insertNode="type => $emit('insertNode', type)"
        placeholder="请设置触发器" :header-bgc="headerBgc" header-icon="el-icon-set-up"/>
</template>

<script>
import Node from './Node'

export default {
  name: 'TriggerNode',
  inject: ['$workflow'],
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {Node},
  data () {
    return {
      showError: false,
      errorInfo: ''
    }
  },
  computed: {
    headerBgc () {
      if (this.$workflow.diagramMode === 'viewer') {
        return this.config.props.headerBgc
      } else {
        return '#ff4500'
      }
    },
    content () {
      const props = this.config.props
      if (props.triggerName) {
        return props.triggerName
      }
      return props.triggerType
    }
  },
  methods: {
    validate (err) {
      this.showError = false
      const props = this.config.props
      const nodeName = this.config.name

      if (!props.triggerType) {
        this.showError = true
        this.errorInfo = '请选择触发器类型'
        err.push(`${nodeName} 未选择触发器类型`)
        return false
      }

      if (props.triggerError) {
        this.showError = true
        this.errorInfo = props.triggerError
        err.push(`${nodeName} ${props.triggerError}`)
        return false
      }

      return true
    }
  }
}
</script>
